import React from "react";
import "../styles/HomepageButton.css";

export default function HomepageButton({ label, onClick, href }) {
  if (href) {
    return (
      <a className="homepage-btn" href={href}>
        {label}
      </a>
    );
  }

  return (
    <button className="homepage-btn" onClick={onClick}>
      {label}
    </button>
  );
}
